import { createCustomSwiper, createSwiperProductBlocks } from '../base.js'
import { addHpBlog } from '../blog/blog.js'
import { createReviewsCarousel } from "../global";

function createCarousel() {
    const carousel = document.querySelector('#carousel')

    if (!carousel) return

    createCustomSwiper('#carousel .carousel-inner', {
        swiperClass: 'hp-carousel',
        pagination: true,
        arrows: false,
        customOptions: {
            loop: true,
        },
    })
}

function addProductsGroupBtn() {
    const groupTitles = document.querySelectorAll('.homepage-group-title')

    groupTitles.forEach((group) => {
        const [title, url, btnText] = group.innerText.split(';')

        if (url) {
            const buttonHTML = /* HTML */ `
                <div class="text-center group-btn-margin">
                    <a href="${url.trim()}" class="btn btn-secondary group-products-btn">
                        ${btnText ? btnText : 'Mehr anzeigen'}
                    </a>
                </div>
            `
            group.nextElementSibling.nextElementSibling
                .querySelector('.swiper-navigation')
                .insertAdjacentHTML('afterend', buttonHTML)

            group.innerText = title.trim()
        }
    })
}

function wrapSectionAndTitle() {
    const section1 = document.querySelector('.section-1');

    if (section1) {

        let title = section1.previousElementSibling;
        while (title && !title.classList.contains('h4')) {
            title = title.previousElementSibling;
        }

        if (title) {
            const wrapper = document.createElement('div');
            wrapper.className = 'section-bg';
            title.parentNode.insertBefore(wrapper, title);
            wrapper.appendChild(title);
            wrapper.appendChild(section1);
        }
    }

}

function transformHighlightTitle() {
    $('.homepage-group-title').each(function() {
        const $this = $(this);
        const currentHtml = $this.html();
        const textarea = document.createElement('textarea');
        textarea.innerHTML = currentHtml;
        const decodedHtml = textarea.value;

        $this.html(decodedHtml);
    });
}

function moveMapWidget(delay) {

    setTimeout(function () {
        const map = $('#chatgo-maps-footer-widget');
        const mapHeader = $('.map-banner .map-banner__header').first();
        if (map.length && mapHeader.length) {
            map.insertAfter(mapHeader);
        }
    }, delay || 500);
}

export function initHomepage() {
    createCarousel()
    createSwiperProductBlocks()
    wrapSectionAndTitle()
    transformHighlightTitle()
    addProductsGroupBtn()
    createReviewsCarousel()
    moveMapWidget()
    // addHpBlog(4)

    $('#carousel').insertBefore('#content-wrapper');
}